export const vehicleDetailsQueryKeys = {
  all: ['vehicle-details-v2'],
  overview: (vehicleId, period) => ['vehicle-details-v2', 'overview', String(vehicleId || ''), period],
  vehicle: (vehicleId) => ['vehicle-details-v2', 'vehicle', String(vehicleId || '')],
  servicePolicy: (vehicleId) => ['vehicle-details-v2', 'service-policy', String(vehicleId || '')],
  serviceEvents: (vehicleId) => ['vehicle-details-v2', 'service-events', String(vehicleId || '')],
  options: () => ['vehicle-details-v2', 'options'],
};

export const invalidateVehicleDetails = (queryClient, vehicleId) => Promise.all([
  queryClient.invalidateQueries({ queryKey: vehicleDetailsQueryKeys.all }),
  queryClient.invalidateQueries({ queryKey: ['tyre-management-v2', 'vehicles'] }),
  queryClient.invalidateQueries({ queryKey: ['tyre-management-v2', 'overview'] }),
  queryClient.invalidateQueries({ queryKey: ['tyre-management-v2', 'vehicle-layout', String(vehicleId || '')] }),
]);
